"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CloseRightBase = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _defaultTo = _interopRequireDefault(require("lodash/defaultTo"));
var _Close = require("./Close");
var _default = (0, _styledComponents["default"])(_Close.Close).withConfig({
  displayName: "CloseRight",
  componentId: "sc-8zcx27-0"
})(["position:absolute;top:", "px;right:15px;float:none;cursor:pointer;"], function (props) {
  return (0, _defaultTo["default"])(props.top, '44');
});
exports["default"] = _default;
var CloseRightBase = (0, _styledComponents["default"])(_Close.CloseBase).withConfig({
  displayName: "CloseRight__CloseRightBase",
  componentId: "sc-8zcx27-1"
})(["position:absolute;right:15px;float:none;cursor:pointer;"]);
exports.CloseRightBase = CloseRightBase;
//# sourceMappingURL=CloseRight.js.map